export const DEBUG = process.env.REACT_APP_STAGE !== 'dev' ? false : true

// API url
export const API_URL = process.env.REACT_APP_API_URL

export const STORYBOOK_ELEMENTS_DIR = 'Elements'
export const STORYBOOK_COLLECTIONS_DIR = 'Collections'
export const STORYBOOK_WIDGETS_DIR = 'Widgets'

export const PUBSUB = {
    APP_ID: process.env.REACT_APP_PUBSUB_APP_ID,
    SECRET: process.env.REACT_APP_PUBSUB_SECRET,
    KEY: process.env.REACT_APP_PUBSUB_KEY,
    CLUSTER: process.env.REACT_APP_PUBSUB_CLUSTER,
  }
  


// WEBPACK FOOTER //
// ./src/parameters.ts